import Vue from 'vue'
import VueRouter from 'vue-router'
import GraphView from '../views/GraphView.vue'
import SvgView from '../views/SvgView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'GraphView'
  },
  {
    path: '/SvgView',
    name: 'SvgView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "svgView" */ '../views/SvgView.vue'),
    meta: {
      title: 'svg'
    }
  },
  {
    path: '/GraphView',
    name: 'GraphView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "GraphView" */ '../views/GraphView.vue'),
    meta: {
      title: '图'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
